import React from 'react';

const Spinner = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 49 49"
    >
      <defs>
        <style></style>
        <clipPath id="clip-path" transform="translate(7.97 7.92)">
          <circle fill="none" cx="16.56" cy="16.56" r="16.56" />
        </clipPath>
        <clipPath id="clip-path-2" transform="translate(7.97 7.92)">
          <path
            fill="none"
            d="M16.53,25.08a8.5,8.5,0,1,1,8.5-8.5A8.5,8.5,0,0,1,16.53,25.08Zm0,16A24.5,24.5,0,1,0-8,16.58,24.5,24.5,0,0,0,16.53,41.08Z"
          />
        </clipPath>
        <clipPath id="clip-path-3" transform="translate(7.97 7.92)">
          <circle fill="none" cx="16.53" cy="16.58" r="16.5" />
        </clipPath>
        <clipPath id="clip-path-4" transform="translate(7.97 7.92)">
          <rect
            fill="none"
            x="-230.97"
            y="-1041.92"
            width="992"
            height="1260"
          />
        </clipPath>
        <clipPath id="clip-path-5" transform="translate(7.97 7.92)">
          <rect fill="none" x="-7.97" y="-7.92" width="49" height="49" />
        </clipPath>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <g clipPath="url(#clip-path)" className="cls-2">
            <g clipPath="url(#clip-path-2)" className="cls-3">
              <g clipPath="url(#clip-path-3)" className="cls-4">
                <g clipPath="url(#clip-path-4)" className="cls-5">
                  <g clipPath="url(#clip-path-5)" className="cls-6">
                    <image
                      width="49"
                      height="49"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAxCAYAAABznEEcAAAACXBIWXMAAAsSAAALEgHS3X78AAAFy0lEQVRoQ91aQZIkNQxMuWoIds9ceAov4I98Yp/FhSsLwUyXOFiSU7Jd3cMRRbhky7Kdacmu7p6R376pAkB/AmoP1tHHdupL/cU++dX+mzlW6ydtjybSDaHtIdEYfWQafaX/meiNQUunxmNPQAE0gAgwEdOpTo3oqwReIBQRCMPcF+B5HGvya4GrEimAOSo1GiEvEAghkJwybmRbTa+qGwjUiogTmNKGouZ9Qu2XhIGjRIgIuO+SCDwSso8EE3HFgMNY5L8SSRF6JRJKkUjgChH2SeiebPuuS2vRHAVOrR0B9j8dmAIQBVS6hnRHERvoxKwPNmESmU0AgAuxol+zS0eyr65aJgDS44q1B+uaUlMkvE0RuQnMhDuA0q46yPDVbFtdtSfQQSpyJJYR8VGMVOeqZPMkDja1iZAbt8CLPoVX9Dql0JaI+9empilCE7aoBOjCKkWHAKuPYw07E2rp4kB98TErZiI0UeJWiVYxwJqbAXhLgOo+zuc54xxUNBwNDIlwS1KjrjZ0kVMMgKMwged+DPsqCqqUTgGWCCy1SyEdbuYrNIzFAUYdhQARAjARiE0kInHFRoesMS/FZ6FoiVpKMnnM+m73PxMFwCKhwHz/3+y+oF/9LEFCBhEOQ4B0/azYoKgjE/M5oR4JYCbAQjbH1kw7GTE/kUGAp3S9S50ViQl0Ae9qHGxzSrdPkVWON3QiDcBlcwURmku1D65gr6LDz8esdExqJG5fYpKzigkIAJW+eFPguoDWAL0GiSmgBPi6DPhFBMgn/IEAi1q39pxO1EzOxe63kKcVmhGR3idUPAJXLdew34K/IwGOBIsikYpoCCLlYuesDi2B1J5ePl2KAJUgYY6r3XdyPDfLTIIIcDS2RBTx8eRyRwCHAfZIOIHHBTweJZUwNmIiEA9qF1s+E8A6rQxIuHqKuMYg1q7hdykgBvjxAD6scBT4LIA0MBNYNAG9ORMs4g9b0Nu8iKqdj9aJtNbt7x8d8D8fwPt7j4Qfah+X5gHJKgILWZ+JnciCa11cAT06uLezm37/A/j+VyewvHFW83xCTkbV9n57sUEcUUFPraMBP/8E/PoL8PVLb8fVWzdEyjyfkBSJpxOUhSPNMMCJ9FQ6GvDDG/D1R+DPv7vP21u3tzZ+K2JSpKbGHbZ0JnaOvAi3WYt0YGIEzqOn09HGmQB6qjUjwi9F38y0qXEAR5pNGGUVieK12iVesEagCXAco4jQ7WTjDvSzIeYfJGQAF9glQkSSuE136VRAc5S2BAQRBU+nZj5Qek/YeG12m/lYB2/13VcCxZjTZX8mNsBdO3gvTUaaJAJAvAcuBYTeIzEnbYi/b7ZECgHg5kwkcgvw7u9gPce9zQVKJKxAAVyA0O0W30MwR2ArUiPBdXusdAVZiURBFiUy/vm9Xf0zVhPEACbg9VUaQTrx9H0C7uiTLMC7z0SgEPNoucRnIy9mi+8i5l6G7YUInTHoBjxA4My+Ai3kR1PG5jlw/9AYn5ewluXuA0FA0Oc504IFdNUM8rbQOJcgIDka3jdJBe9ttls9fu2INb1ewCxJYGPzyZhISu5Cwv12ISEJDkTm5AWjWoAzoVXqJMwy6szBxSMiQiTKzrqIkYUgrlxw23zSwQ7w9ghNoMcK1FfJxSRZGLwDL7jHuBoVIvA0ne6iEHYC7HMF5tRYiAHgF1ntAxCdEY1h6loQ0Vgf7GcEMOwSjZkYa95EMQNvKFdqenFazROB/gT8GQJS2mM+oNRXosib7unlxY38PsFO65NI1NTyviSFxR0B2rzerulTHMXqfKA5Mn6+0g/KdwQcqPfVKMSYVSGwiQgD906zc0rVv2AlItjdTkUHeGA4e70CKd0r4QAkgw/QsXa9YutVC/i3RNkTSJEwldILXBlywy1LZaRDce6rGSet+D/9RwH2kQiSlRjZQl5Gj7zjILBmfDkS4CuWNYZO9UKMyYW8QCTtOLiSAZeuqFci/wIfVzvdDq3B4gAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Spinner;
